// Service worker registration for Scalimmo PWA

export function registerServiceWorker() {
    if (typeof window === 'undefined') return;
    if (!('serviceWorker' in navigator)) return;
    // Skip in dev mode (CRA hot reload conflicts with SW caching)
    if (process.env.NODE_ENV !== 'production') return;

    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/service-worker.js')
            .then((registration) => {
                // Listen for updates
                registration.addEventListener('updatefound', () => {
                    const installing = registration.installing;
                    if (!installing) return;
                    installing.addEventListener('statechange', () => {
                        if (installing.state === 'installed' && navigator.serviceWorker.controller) {
                            // New version available — could prompt user to refresh
                            window.dispatchEvent(new CustomEvent('scalimmo:sw-update', { detail: registration }));
                        }
                    });
                });
            })
            .catch((err) => {
                console.warn('SW registration failed:', err);
            });
    });
}
